import { deleteData, getData, postData, putData } from "../api/api";
import type {
  SchemaGraph,
  SchemaGraphEdge,
  SchemaGraphNode,
} from "../types/schemaAnalytics";

export type SchemaNodeUpsertRequest = Partial<SchemaGraphNode> & { indexName: string };
export type SchemaEdgeUpsertRequest = Partial<SchemaGraphEdge> & {
  fromIndex: string;
  toIndex: string;
};
export type SchemaSampleEnrichRequest = {
  consentGiven: boolean;
  indexNames?: string[];
  sampleSize?: number;
};

export const schemaAnalyticsService = {
  getGraph: () => getData("/schema-analytics/graph", { skipGlobalLoading: true }) as Promise<SchemaGraph>,

  kvkkNotice: () =>
    getData("/schema-analytics/kvkk-notice", { skipGlobalLoading: true }) as Promise<{ notice: string }>,

  analyze: () => postData("/schema-analytics/analyze", {}) as Promise<SchemaGraph>,

  enrichSamples: (body: SchemaSampleEnrichRequest) =>
    postData("/schema-analytics/enrich-samples", body) as Promise<SchemaGraph>,

  publish: () => postData("/schema-analytics/publish", {}) as Promise<SchemaGraph>,

  discard: () => postData("/schema-analytics/discard", {}, { skipGlobalLoading: true }) as Promise<SchemaGraph>,

  upsertNode: (body: SchemaNodeUpsertRequest) =>
    putData("/schema-analytics/nodes", body) as Promise<SchemaGraph>,

  updatePositions: (positions: SchemaNodeUpsertRequest[]) =>
    putData("/schema-analytics/nodes/positions", positions) as Promise<SchemaGraph>,

  deleteNode: (indexName: string) =>
    deleteData(`/schema-analytics/nodes/${encodeURIComponent(indexName)}`) as Promise<SchemaGraph>,

  upsertEdge: (body: SchemaEdgeUpsertRequest) =>
    putData("/schema-analytics/edges", body) as Promise<SchemaGraph>,

  deleteEdge: (edgeId: string) =>
    deleteData(`/schema-analytics/edges/${encodeURIComponent(edgeId)}`) as Promise<SchemaGraph>,
};
